import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { EASE_OUT_EXPO } from '../../../../components/AnimatedSection/AnimatedSection';
import './JoinExpectSection.scss';

const JoinExpectSection = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    return (
        <section className="join-expect">
            <div className="join-expect__outer">
                <div className="join-expect__container">
                    <motion.h2 className="join-expect__title" {...fadeUp(0, 1.1)}>{t('join_expect_title')}</motion.h2>

                    <div className="join-expect__grid">
                        <motion.div className="join-expect__item" {...fadeUp(0.3 + 0 * 0.12)}>
                            <span className="join-expect__number">1</span>
                            <p className="join-expect__text">
                                {t('join_expect_1')}
                            </p>
                        </motion.div>

                        <motion.div className="join-expect__item" {...fadeUp(0.3 + 1 * 0.12)}>
                            <span className="join-expect__number">2</span>
                            <p className="join-expect__text">
                                {t('join_expect_2')}
                            </p>
                        </motion.div>

                        <motion.div className="join-expect__item" {...fadeUp(0.3 + 2 * 0.12)}>
                            <span className="join-expect__number">3</span>
                            <p className="join-expect__text">
                                {t('join_expect_3')}
                            </p>
                        </motion.div>

                        <motion.div className="join-expect__item" {...fadeUp(0.3 + 3 * 0.12)}>
                            <span className="join-expect__number">4</span>
                            <p className="join-expect__text">
                                {t('join_expect_4')}
                            </p>
                        </motion.div>

                        <motion.div className="join-expect__item" {...fadeUp(0.3 + 4 * 0.12)}>
                            <span className="join-expect__number">5</span>
                            <p className="join-expect__text">
                                {t('join_expect_5')}
                            </p>
                        </motion.div>

                        <motion.div className="join-expect__item" {...fadeUp(0.3 + 5 * 0.12)}>
                            <span className="join-expect__number">6</span>
                            <p className="join-expect__text">
                                {t('join_expect_6')}
                            </p>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default JoinExpectSection;